import { createSlice,PayloadAction } from '@reduxjs/toolkit';

interface RightSideAdState {
  isVisible: boolean | null;
  adComponent: number;
}
//initial state for rightSideAd
const initialState: RightSideAdState = {
    isVisible: false,
    adComponent: 0
};

const rightSideAdSlice = createSlice({
  name: 'rightSideAd',
  initialState,
  reducers: {
    visibility(state,action: PayloadAction<{isVisible: boolean}>) {
      state.isVisible = action.payload.isVisible;
    },
    changeAdComponent(componentName,action: PayloadAction<{adComponent: number}>){
      componentName.adComponent = action.payload.adComponent;
    }
  },
});

export const { visibility, changeAdComponent } = rightSideAdSlice.actions;
export default rightSideAdSlice.reducer;
